// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { InstrumentConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/Instrument';
import { DetailsRow } from '../../../components/DetailsRow';
import PartyDisplay from '../../../components/PartyDisplay';
import { DetailsLayout } from '../../../components/Table/DetailsLayout';
import RequiredCredentials from '../../../modules/Credential/RequiredCredentials';
import InstrumentIdentifiers from '../../../modules/Instrument/InstrumentIdentifiers';
import TemplateContract from '../../../utils/TemplateContract';

interface InstrumentConfigurationDetailsProps {
  row?: TemplateContract<InstrumentConfiguration>;
}
export const InstrumentConfigurationDetails: React.FC<InstrumentConfigurationDetailsProps> = ({
  row,
}) => {
  if (!row) {
    return null;
  }
  const details = [
    {
      label: 'instrument id',
      value: row?.payload.defaultIdentifier.id,
    },
    {
      label: 'registrar',
      value: <PartyDisplay party={row?.payload.registrar} />,
    },
    {
      label: 'operator',
      value: <PartyDisplay party={row?.payload.operator} />,
    },
    {
      label: 'provider',
      value: <PartyDisplay party={row?.payload.provider} />,
    },
    {
      label: 'additional identifiers',
      value: (
        <InstrumentIdentifiers
          enableWrap
          instrumentIdentifiers={row.payload.additionalIdentifiers}
        />
      ),
    },
    {
      label: 'Required credentials for issuers',
      value: <RequiredCredentials credentialRequirements={row.payload.issuerRequirements} />,
    },
    {
      label: 'Required credentials for holders',
      value: <RequiredCredentials credentialRequirements={row.payload.holderRequirements} />,
    },
  ];
  return (
    <DetailsLayout>
      {details.map((detail) => (
        <DetailsRow label={detail.label} key={detail.label} value={detail.value} />
      ))}
    </DetailsLayout>
  );
};
